import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ng6-toastr-notifications';
import { SimpleMenuComponent } from './admin/simple.menu.component';
import { ContextMenuModule } from '@ctrl/ngx-rightclick';
import { ConfirmPasswordComponent } from './admin/confirm-password/confirm-password.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './shared.module';
import { HotkeyModule } from 'angular2-hotkeys';
import { QuestionComponent } from './admin/confirm-password/question-password.component';
import { ModalDialogModule } from 'ngx-modal-dialog';
import { NewspaperModule } from './admin/newspaper/newspaper.module';
import { MatProgressBarModule } from '@angular/material';
import { AddHeaderInterceptor } from './services/header.interceptor';
import { QuestionPrintComponent } from './admin/confirm-password/question-print.component';
import { BuysellModule } from './admin/buysell/buysell.module';
import { AdminModule } from './admin/admin.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { InputsModule } from '@progress/kendo-angular-inputs';



@NgModule({
  declarations: [
    AppComponent,
    ConfirmPasswordComponent,
    QuestionComponent,
    QuestionPrintComponent,
    SimpleMenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    ContextMenuModule,
    HotkeyModule.forRoot(),
    MatProgressBarModule,
    NgxPermissionsModule.forChild(),
    // AdminModule
    NgbModule.forRoot(),
    InputsModule
    ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AddHeaderInterceptor, multi: true},
  ],
  bootstrap: [AppComponent],
  entryComponents:[
      ConfirmPasswordComponent,
      QuestionComponent,
      QuestionPrintComponent,
      SimpleMenuComponent,
    ]
})
export class AppModule { }
